import { render } from "./Sets.vue?vue&type=template&id=3dd72984&scoped=true"
import script from "./Sets.vue?vue&type=script&lang=js"
export * from "./Sets.vue?vue&type=script&lang=js"

import "./Sets.vue?vue&type=style&index=0&id=3dd72984&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd72984"]])

export default __exports__